import Statistic from 'antd/lib/statistic'

import 'antd/lib/statistic/style'

export * from 'antd/lib/statistic'

export default Statistic
